export default class StudentsBookletIndex {
    constructor() {
        this.bindEvents();
    }

    bindEvents() {
        var self = this;
        $('.profile_image_input').on('change', function(event) {
            const file = event.target.files[0];
            if (file && self.handleFiles(this.files)) {
              const reader = new FileReader();
              reader.onload = function(e) {
                $('.profile_image_preview').attr('src', e.target.result);
              }
              reader.readAsDataURL(file);
            }

            var url = $(this).data('url'); 
            if (file && self.valid_file(file)) {
              const formData = new FormData();
              formData.append('customer[profile_image]', file);

              $.ajax({
                url: url,
                type: 'PATCH',
                data: formData,
                contentType: false,
                processData: false,
                success: function(response) {
                  if (response.success) {
                    $('.profile_image_preview').attr('src', response.image_url);
                    application.successNotification('Photo mise à jour avec succès.');
                  } else {
                    application.errorNotification('Une erreur est survenue lors de la mise à jour de l\'image.');
                  }
                },
                error: function(xhr) {
                  application.errorNotification('Une erreur est survenue lors de la mise à jour de l\'image.');
                }
              });
            }
          });
    }

    handleFiles(files) {
        let file = files[0]
        if(this.valid_file(file)){
            this.previewFile(file);
        }
    }

    previewFile(file) {
        let reader = new FileReader();

        reader.onload = function(e) {
            $('.profile_image_preview').attr('src', e.target.result);
        }
        //this.file = file;
        reader.readAsDataURL(file); // convert to base64 string
    }

    valid_file(file) {
        const allowedTypes = ['image/jpg', 'image/jpeg', 'image/png'];
        if (!allowedTypes.includes(file.type)) {
            $("#profile_image_error").remove();
            $(".personal-info-container")
                .css('border', '2px solid red')
                .after(
                    `<div id="profile_image_error">
                        ${I18n.t('students.administrative_files.personal_info.invalid_image_format', { formats: 'JPG, JPEG, PNG' })}
                    </div>`
                );
            return false;
        }
        // Remove error message and border if file is valid
        $("#profile_image_error").remove();
        $(".personal-info-container").css('border', '');
        return true;
    }
}